import axios from 'axios';
// import { BASE_URL } from './ip';
import {
  CLIENT_LOGO_REQUEST,
  CLIENT_LOGO_SUCCESS,
  CLIENT_LOGO_FAIL,
  CREATE_NEW_USER_REQUEST,
  CREATE_NEW_USER_SUCCESS,
  CREATE_NEW_USER_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  GET_LOGGED_USER_DETAILS_RESET,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAIL,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  SELECT_USER_REQUEST,
  SELECT_USER_SUCCESS,
  SELECT_USER_FAIL,
  UPDATE_USER_STATUS_REQUEST,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  RESET_USER_PASSWORD_REQUEST,
  RESET_USER_PASSWORD_SUCCESS,
  RESET_USER_PASSWORD_FAIL,
  GET_LOGGED_USER_DETAILS_REQUEST,
  GET_LOGGED_USER_DETAILS_SUCCESS,
  GET_LOGGED_USER_DETAILS_FAIL,
  CHANGE_LOGGED_IN_USER_PASSWORD_REQUEST,
  CHANGE_LOGGED_IN_USER_PASSWORD_SUCCESS,
  CHANGE_LOGGED_IN_USER_PASSWORD_FAIL,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  VERIFY_PASSWORD_OTP_REQUEST,
  VERIFY_PASSWORD_OTP_SUCCESS,
  VERIFY_PASSWORD_OTP_FAIL,
  UPDATE_LOGGED_USER_DETAILS_REQUEST,
  UPDATE_LOGGED_USER_DETAILS_SUCCESS,
  UPDATE_LOGGED_USER_DETAILS_FAIL,
  DELETE_ME_REQUEST,
  DELETE_ME_SUCCESS,
  DELETE_ME_FAIL,
  ONLINE_USERS,
  ALL_NOTIFICATIONS_RESET,
  ORG_USER_COUNT_REQUEST,
  ORG_USER_COUNT_SUCCESS,
  ORG_USER_COUNT_FAIL,
  SET_LOGGED_USER_DETAILS_IN_USER_LOGIN,
  GET_ALL_LOGS_SUCCESS,
  GET_ALL_LOGS_FAIL,
  GET_ALL_LOGS_REQUEST,
} from '../constants/userConstants';
import {
  GET_FOLDER_DATA_RESET,
  GET_SUB_FOLDER_DATA_RESET,
  GET_SUB_SUB_FOLDER_DATA_RESET,
  GET_SUB_SUB_SUB_FOLDER_DATA_RESET,
  GET_SUB_SUB_SUB_SUB_FOLDER_DATA_RESET,
} from '../constants/folderConstants';
import { clearRememberedEmail } from '../../utils/deviceFingerprint';
import { fetchTenantConfig } from './tenantConfigActions';
import { TENANT_CONFIG_RESET } from '../constants/tenantConfigConstants';

const BASE_URL = process.env.REACT_APP_BASE_URL;
// console.log(BASE_URL);
axios.defaults.withCredentials = true;
export const multiUserLogin = (token, password) => async dispatch => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/token-generated-by-email`, { token, ciperText: password }, config);

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });
    localStorage.setItem('userInfo', JSON.stringify(data));
    dispatch(getLoggedinUserAction());
    return data;
  } catch (err) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const login = (email, password, ciperText, rememberDevice = false) => async dispatch => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/login`, { ciperText, rememberDevice }, config);

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });
    localStorage.setItem('userInfo', JSON.stringify(data));
    // Only fetch user details when the session is fully established (no TOTP pending)
    if (data.status !== 'totp_required' && data.status !== 'totp_enrollment_required') {
      dispatch(getLoggedinUserAction());
    }
  } catch (err) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

// `mfaChallenge` is the opaque, single-use, server-side challenge minted by
// the password step. It replaces the user id this used to send: /totp/check
// resolves the user FROM the challenge, so a caller can no longer nominate
// which account it is completing a second factor for.
export const verifyTotpLogin = (mfaChallenge, code) => async dispatch => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = { headers: { 'Content-Type': 'application/json' } };
    const { data } = await axios.post(`${BASE_URL}/users/totp/check`, { mfaChallenge, code }, config);

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem('userInfo', JSON.stringify(data));
    dispatch(getLoggedinUserAction());
  } catch (err) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

// Step 1 of forced enrollment: fetch the QR code using the MFA challenge.
export const totpEnrollSetup = (mfaChallenge) => async () => {
  const config = { headers: { 'Content-Type': 'application/json' } };
  const { data } = await axios.post(`${BASE_URL}/users/totp/enroll-setup`, { mfaChallenge }, config);
  return data;
};

// Step 2 of forced enrollment: verify code + get session
export const totpEnrollVerify = (mfaChallenge, code) => async dispatch => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = { headers: { 'Content-Type': 'application/json' } };
    const { data } = await axios.post(`${BASE_URL}/users/totp/enroll-verify`, { mfaChallenge, code }, config);

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem('userInfo', JSON.stringify(data));
    dispatch(getLoggedinUserAction());
  } catch (err) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const getClientLogoAction = () => async (dispatch) => {
  try {
    dispatch({ type: CLIENT_LOGO_REQUEST });

    const { data } = await axios.get(`${BASE_URL}/users/get-logo`, { withCredentials: true });

    dispatch({
      type: CLIENT_LOGO_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: CLIENT_LOGO_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const createNewUserAction = userData => async (dispatch, getState) => {
  try {
    dispatch({ type: CREATE_NEW_USER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/`, userData, config);

    dispatch({
      type: CREATE_NEW_USER_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: CREATE_NEW_USER_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};
export const allocateUserSpaceAction = (userId, allowedStorage) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.patch(`${BASE_URL}/users/update/${userId}/storage`, { allowedStorage }, config);

    return data;
  } catch (err) {
    return err.response && err.response.data ? err.response.data : err.message;
  }
};

export const getAllUsers =
  (page, limit, selectedClient = '', selectedRole = '', searchText) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_USERS_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          'Content-Type': 'application/json',
        },
      };

      let uri =
        selectedClient === ''
          ? selectedRole === ''
            ? `${BASE_URL}/users?page=${page}&limit=${limit}`
            : `${BASE_URL}/users?page=${page}&limit=${limit}&role=${selectedRole}`
          : selectedRole === ''
          ? `${BASE_URL}/users?page=${page}&limit=${limit}&org=${selectedClient}`
          : `${BASE_URL}/users?page=${page}&limit=${limit}&org=${selectedClient}&role=${selectedRole}`;

      if (searchText) uri = uri + `&search=${searchText}`;
      // if (role) {
      // 	uri = `${BASE_URL}/users?page=${page}&role=${role}`;
      // }
      const { data } = await axios.get(uri, config);

      dispatch({
        type: GET_ALL_USERS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ALL_USERS_FAIL,
        payload: err.response && err.response.data.message ? err.response.data.message : err.message,
      });
    }
  };

export const getOrgUserCount = clientId => async (dispatch) => {
  try {
    dispatch({ type: ORG_USER_COUNT_REQUEST });
    const { data } = await axios.get(`${BASE_URL}/orgs/${clientId}/total-users`, { withCredentials: true });

    dispatch({
      type: ORG_USER_COUNT_SUCCESS,
      payload: data,
    });

    return data;
  } catch (err) {
    dispatch({
      type: ORG_USER_COUNT_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
    return err.response && err.response.data.message ? err.response.data.message : err.message;
  }
};

export const selectUserAction = id => async (dispatch, getState) => {
  try {
    dispatch({ type: SELECT_USER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(`${BASE_URL}/users/${id}`, config);

    dispatch({
      type: SELECT_USER_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: SELECT_USER_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const updateUserAction = (id, formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_USER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.patch(`${BASE_URL}/users/${id}`, formData, config);

    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_USER_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const toggleUserActive = (id, active) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_USER_STATUS_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.patch(`${BASE_URL}/users/${id}/toggleActive`, { active }, config);
    dispatch({
      type: UPDATE_USER_STATUS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_USER_STATUS_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const deleteUserAction = id => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_USER_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    await axios.delete(`${BASE_URL}/users/${id}`, config);

    dispatch({ type: DELETE_USER_SUCCESS, payload: { status: 'Success' } });
  } catch (err) {
    dispatch({
      type: DELETE_USER_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const resetPasswordAction = (id, newPassword) => async (dispatch, getState) => {
  try {
    dispatch({ type: RESET_USER_PASSWORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    await axios.patch(`${BASE_URL}/users/${id}/reset-password`, { password: newPassword }, config);

    dispatch({
      type: RESET_USER_PASSWORD_SUCCESS,
      payload: { status: 'Success' },
    });
  } catch (err) {
    dispatch({
      type: RESET_USER_PASSWORD_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const getLoggedinUserAction = () => async dispatch => {
  try {
    dispatch({ type: GET_LOGGED_USER_DETAILS_REQUEST });

    // Backend uses cookie-only auth (no token in login response body).
    // axios.defaults.withCredentials = true sends the auth cookie automatically.
    const { data } = await axios.get(`${BASE_URL}/users/get-user`);
    dispatch({
      type: GET_LOGGED_USER_DETAILS_SUCCESS,
      payload: data,
    });
    dispatch({
      type: SET_LOGGED_USER_DETAILS_IN_USER_LOGIN,
      payload: data,
    });
    // Load this user's tenant config so the sidebar and locale render
    // per-tenant on the next paint. Fire-and-forget — failures don't block.
    dispatch(fetchTenantConfig());
  } catch (err) {
    dispatch({
      type: GET_LOGGED_USER_DETAILS_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const updateLoggedinUserDetails = formData => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_LOGGED_USER_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.patch(`${BASE_URL}/users/updateMe`, formData, config);

    dispatch({
      type: UPDATE_LOGGED_USER_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_LOGGED_USER_DETAILS_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const deleteMeAction = () => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_ME_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    await axios.delete(`${BASE_URL}/users/deleteMe`, config);

    dispatch({ type: DELETE_ME_SUCCESS });
  } catch (err) {
    dispatch({
      type: DELETE_ME_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

// export const unsubscribeClientAction = () => async (dispatch, getState) => {
//   try {
//     dispatch({ type: DELETE_ME_REQUEST });

//     const {
//       userLogin: { userInfo },
//     } = getState();

//     const config = {
//       headers: {
//         Authorization: `Bearer ${userInfo.token}`,
//         'Content-Type': 'application/json',
//       },
//     };

//     await axios.get(`${BASE_URL}/users/onboard/cancel-subscription`, config);

//     dispatch({ type: DELETE_ME_SUCCESS });
//   } catch (err) {
//     dispatch({
//       type: DELETE_ME_FAIL,
//       payload: err.response && err.response.data.message ? err.response.data.message : err.message,
//     });
//   }
// };

export const changeLoggedInUserPasswordAction = (password, newPassword) => async (dispatch, getState) => {
  try {
    dispatch({ type: CHANGE_LOGGED_IN_USER_PASSWORD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/updatePassword`, { password, newPassword }, config);

    dispatch({
      type: CHANGE_LOGGED_IN_USER_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: CHANGE_LOGGED_IN_USER_PASSWORD_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const forgotPasswordAction = email => async dispatch => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/forget-password`, { email }, config);

    dispatch({
      type: FORGOT_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: FORGOT_PASSWORD_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const verifyPasswordOtpAction = (email, otp, password) => async dispatch => {
  try {
    dispatch({ type: VERIFY_PASSWORD_OTP_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.post(`${BASE_URL}/users/verify-password`, { email, otp, password }, config);

    dispatch({
      type: VERIFY_PASSWORD_OTP_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: VERIFY_PASSWORD_OTP_FAIL,
      payload: err.response && err.response.data.message ? err.response.data.message : err.message,
    });
  }
};

export const checkTokenAction = () => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const { loggedinUser } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo?.token}`,
        'Content-Type': 'application/json',
      },
    };

    let { data } = await axios.get(`${BASE_URL}/users/check-token`, config);
    dispatch(getLoggedinUserAction());
    data.user = loggedinUser;
    return data;
  } catch (err) {
    // dispatch(logout());
    return err.response && err.response.data ? err.response.data : err;
  }
};

export const getAllLogsAction =
  (page, tags = [], selectedClient = '', searchText, startDate, endDate, userId = '', pageSize=10) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_LOGS_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
          'Content-Type': 'application/json',
        },
      };

      let uri = `${BASE_URL}/logs?pageNumber=${page}&pageSize=${pageSize}`;

      if (tags.length) uri = uri + `&tags=${tags}`;
      if (selectedClient) uri = uri + `&client=${selectedClient}`;
      if (userId) uri = uri + `&user=${userId}`;
      if (searchText) uri = uri + `&search=${searchText}`;
      if (startDate && endDate) uri = uri + `&startDate=${startDate}&endDate=${endDate}`;

      // console.log(startDate, endDate);

      const { data } = await axios.get(uri, config);

      dispatch({
        type: GET_ALL_LOGS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: GET_ALL_LOGS_FAIL,
        payload: err.response && err.response.data.message ? err.response.data.message : err.message,
      });
    }
  };

export const getLogDetailsAction = id => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    let uri = `${BASE_URL}/logs/${id}`;
    const { data } = await axios.get(uri, config);

    return data;
  } catch (err) {
    return err.response && err.response.data.message ? err.response.data.message : err.message;
  }
};

export const getAllLogsActionByModule = query => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };
    const { data } = await axios.get(`${BASE_URL}/logs??module=file&search=${query}`, config);

    return data;
  } catch (err) {
    return err.response && err.response.data.message ? err.response.data.message : err.message;
  }
};

export const getAllFilters = () => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(`${BASE_URL}/logs/filter`, config);
    return data?.data;
  } catch (err) {
    return err.response && err.response.data.message ? err.response.data.message : err.message;
  }
};

export const refreshUserAction = userId => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
        'Content-Type': 'application/json',
      },
    };

    const uri = userId ? `${BASE_URL}/folders/update-folder-id?id=${userId}` : `${BASE_URL}/folders/update-folder-id`;

    const { data } = await axios.put(uri, {}, config);

    return data;
  } catch (err) {
    return err.response && err.response.data.message ? err.response.data.message : err.message;
  }
};

const useLogout = async () => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    await axios.put(`${BASE_URL}/users/logout`, config);
    localStorage.clear();
  } catch (err) {
    return console.error(err);
  }
};

export const logout = () => async () => {
  // Full-reload strategy: reload() halts JS before React can flush a
  // cleared-state render, so no error-boundary crash on screens like
  // Team Management with many userInfo/tenantConfig selectors.
  //
  // The previous version fire-and-forgot useLogout() and reloaded
  // immediately — reload() interrupted the pending axios POST to
  // /users/logout AND the localStorage.clear() that ran after it. Net
  // result: server auth cookie stayed set, localStorage stayed
  // populated, and the fresh page load re-authenticated straight back
  // to the dashboard (reported for Yann's account after 678595b
  // deploy). Fix: await useLogout with a short timeout so the cookie
  // clear + localStorage clear complete before reload; and clear
  // localStorage ourselves as a belt-and-braces guard in case the
  // server call times out or errors (auth cookie is HttpOnly so JS
  // cannot clear it — the server round-trip is load-bearing).
  const timeout = new Promise((resolve) => setTimeout(resolve, 3000));
  try {
    await Promise.race([useLogout(), timeout]);
  } catch (_) { /* server unreachable — reload still helps */ }
  clearRememberedEmail();
  try { localStorage.clear(); } catch (_) {}
  if (typeof window !== 'undefined' && window.location) {
    const base = window.location.pathname + window.location.search;
    window.location.replace(base + '#/login');
    window.location.reload();
  }
};
